import { WireContourService } from '@3d-scene/common/util/wire-contour-service';
import { ArticleBehaviorPropertyDef } from '@article/constants/article-behavior-property-def';
import { Observable, Subject } from 'rxjs';
import { Injectable } from '@angular/core';

export interface AdminServiceAction {
  action: string;
  data?: any;
}
/**
 * Service for AdminTool component
 */
@Injectable({ providedIn: 'root' })
export class AdminService {
  public readonly ACTION_TOGGLE_POSITION_CURSOR: string = 'togglePositionCursor';
  public readonly ACTION_TOGGLE_PICK_CONNECTOR_POSITION_MODE: string = 'togglePickConnectorPositionMode';
  public readonly ACTION_UPDATE_PROPERTIES: string = 'updateProperties';

  private _adminServiceAction$: Subject<AdminServiceAction> = new Subject<AdminServiceAction>();

  constructor(private readonly wireContourService: WireContourService) {
  }

  public get adminServiceAction$(): Observable<AdminServiceAction> {
    return this._adminServiceAction$.asObservable();
  }

  public togglePickConnectorPositionMode(force?: boolean): void {
    const action: AdminServiceAction = {
      action: this.ACTION_TOGGLE_PICK_CONNECTOR_POSITION_MODE,
      data: force,
    };
    this._adminServiceAction$.next(action);
  }

  public togglePositionCursor(force?: boolean): void {
    const action: AdminServiceAction = {
      action: this.ACTION_TOGGLE_POSITION_CURSOR,
      data: force,
    };
    this._adminServiceAction$.next(action);
  }

  public updateProperties(changedProperties: string[] | undefined = undefined): void {
    const action: AdminServiceAction = {
      action: this.ACTION_UPDATE_PROPERTIES,
    };
    this._adminServiceAction$.next(action);

    if(changedProperties == undefined || changedProperties.includes(ArticleBehaviorPropertyDef.CONTOUR_THRESHOLD_ANGLE)) {
      this.wireContourService.redrawAllWireContours();
    }
  }
}
